import React from "react";
import { GrEdit } from "react-icons/gr";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { FaSearch } from "react-icons/fa";
import { GrRefresh} from "react-icons/gr";
import { MdVisibility} from "react-icons/md";

import { Stack, Button, Form, Table } from "react-bootstrap";
import getAllFormularios from "../functions/getAllFormularios";
import eliminarProductoHome from "../functions/eliminarProductoHome";
import filtrarDatos from "../functions/filtrarDatos";

//modales
import ModalAñadir from "../components/ModalAñadirFormularios";
import ModalEditar from "../components/ModalEditarFormularios";
import { Container } from "reactstrap";

function Formularios({ usuario }) {
  const ruc = usuario.ruc;
  const [productos, setProductos] = React.useState([]);
  const [isModalAñadir, setIsModalAñadir] = React.useState(false);
  const [isModalEditar, setIsModalEditar] = React.useState(false);
  const [productoEditar, setProductoEditar] = React.useState(null);

  const baseDatos = `formularios`;
  
  async function busquedaFormHandler(e) {
    e.preventDefault();
    const busqueda = e.target.busqueda.value;
    const nvosDocus = await filtrarDatos(busqueda, baseDatos);
    setProductos(nvosDocus);
  }

  function actualizarEstadoProductos(db) {
    getAllFormularios(db, ruc).then((productos) => {
      setProductos(productos);
    });
  }

  function añadirProductoHome() {
    setIsModalAñadir(true);
  }

  React.useEffect(() => {
    actualizarEstadoProductos(baseDatos);
  }, [baseDatos]);

  return (
    <Container className="my-5">
    <h2>Formularios</h2>
    <div>
      <ModalAñadir
        isModalAñadir={isModalAñadir}
        setIsModalAñadir={setIsModalAñadir}
        actualizarEstadoProductos={actualizarEstadoProductos}
        usuario={usuario}
      />
      {productoEditar && (
        <ModalEditar
          isModalEditar={isModalEditar}
          setIsModalEditar={setIsModalEditar}
          actualizarEstadoProductos={actualizarEstadoProductos}
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
        />
      )}
      

      <Form onSubmit={busquedaFormHandler}>
        <Stack direction="horizontal">
          <Form.Group controlId="busqueda" className="w-75 m-3">
            <Form.Control type="text" placeholder="Buscar" />
          </Form.Group>
          <Button 
          variant="light" 
          type="submit">
            <FaSearch size="20px" color="blue"/>
          </Button>
          <Button
            variant="light"
            onClick={() => {
              const input = document.getElementById("busqueda");
              input.value = "";
              actualizarEstadoProductos(baseDatos);
            }}
          >
            <GrRefresh size="20px" color="blue" />
          </Button>
        </Stack>
      </Form>

      <hr />
      <Table>
        <thead>
          <tr>
                <th scope="col">N°</th>
                <th scope="col">Estado</th>
                <th scope="col">Código</th>
                <th scope="col">Nombre</th>
                <th scope="col">Descripción</th>
                <th scope="col">Revisión</th>
                <th scope="col">Orden</th>
                <th scope="col">URL</th>
                <th scope="col">Acciones</th>
              </tr>
        </thead>
        <tbody>
          {productos &&
            productos.map((producto, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                {producto.activo ? (
                  <td>
                    Activo
                  </td>
                ) : (
                  <td>
                    Inactivo
                  </td>
                )}
                <td>{producto.codigo}</td>
                <td>{producto.nombre}</td>
                <td>{producto.descripcion.substr(0,20)+"...."}</td>
                <td>{producto.rev}</td>
                <td>{producto.orden}</td>
                <td><a href={producto.url} target="_blank" rel="noreferrer">
                  <MdVisibility size="20px" color="#0CB7F2"/></a></td>
                <td>
                  <Button
                    variant="light"
                    onClick={() => {
                      setProductoEditar({ ...producto });
                      setIsModalEditar(true);
                    }}
                  >
                    <GrEdit size="20px" color="black"/>
                  </Button >{" "}
                  <Button
                    variant="light"
                    onClick={() => {
                      eliminarProductoHome(producto, usuario.email, baseDatos).then(
                        (confirmacion) => {
                          actualizarEstadoProductos(baseDatos);
                        }
                      );
                    }}
                  >
                    <RiDeleteBin6Fill size="21px" color="red"/>
                  </Button>{" "}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      <Button onClick={añadirProductoHome}> Añadir Formulario</Button>
    </div>
    </Container>
  );
}

export default Formularios;
